"use strict";
/*
 * Created on 17.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var WindowOverviewFlag_1 = require("./WindowOverviewFlag");
/**
 * DTO object for a {@link Window window} containing all additional info for Window
 *
 * @author MSu
 * @author JMt
 * @author Tomáš Leity
 */


var WindowOverviewDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowOverviewDTO, _DomainObject_1$Domai);

  /**
   * Creates new instance of WindowFileOverviewDTO.
   *
   * @param id - Window ID.
   * @param locked - Flag expressing lockout of window for editing.
   * @param lockedForCurrentUser
   * @param promoDiscount - typical discount %
   * @param promoPrice - typical promo price
   * @param flags - flag set
   * @param lockOwnersName
   * @param productIds
   * @param productsNo
   */
  function WindowOverviewDTO(id, locked, lockedForCurrentUser, promoDiscount, promoPrice, flags, lockOwnersName, productIds, productsNo, sales, promoVolume) {
    var _this;

    _classCallCheck(this, WindowOverviewDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewDTO).call(this));
    _this.id = id;
    _this.locked = locked;
    _this.lockedForCurrentUser = lockedForCurrentUser;
    _this.promoDiscount = promoDiscount;
    _this.promoPrice = promoPrice;
    _this.flags = flags;
    _this.lockOwnersName = lockOwnersName;
    _this.productIds = productIds;
    _this.productsNo = productsNo;
    _this.sales = sales;
    _this.promoVolume = promoVolume;
    return _this;
  }

  return WindowOverviewDTO;
}(DomainObject_1.DomainObject);

exports.WindowOverviewDTO = WindowOverviewDTO;

WindowOverviewDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowOverviewDTO.name);
  return {
    id: builder.id('id'),
    locked: builder.bool('locked'),
    lockedForCurrentUser: builder.bool('lockedForCurrentUser'),
    promoDiscount: builder.opt(builder.bigNum('promoDiscount')),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    flags: builder.flags('flag', WindowOverviewFlag_1.WindowOverviewFlag),
    lockOwnersName: builder.opt(builder.str('lockOwnersName')),
    productIds: builder.opt(builder.str('productIds')),
    productsNo: builder.opt(builder.num('productsNo')),
    sales: builder.opt(builder.bigNum('sales')),
    promoVolume: builder.opt(builder.bigNum('promoVolume'))
  };
}();